// Whether the browser has a connection, so the console can say so instead of
// failing read after read (Yaoundé's mobile data drops; the data on screen
// stays, dated, and everything reads again when the connection is back).
import { useSyncExternalStore } from 'react';

const sub = (f: () => void) => {
  addEventListener('online', f); addEventListener('offline', f);
  return () => { removeEventListener('online', f); removeEventListener('offline', f); };
};

export const useOnline = () => useSyncExternalStore(sub, () => navigator.onLine, () => true);
